<template>
    <div class="app" style="height: 100%;">
        <div>
            <EqCell title="申请编码:" value="张*"></EqCell>
            <EqCell title="项目:" value="158******1237"></EqCell>
            <EqCell title="租户公司:" value="362430********203x"></EqCell>
            <EqCell title="有效期至:" value="上海来福士"></EqCell>
            <EqCell title="开票状态:" value="每日每日优鲜有限责任公司"></EqCell>
        </div>
    </div>
</template>
<script>
import EqCell from "@/components/Commons/EqCell";

export default {
    name: "EqInvoicingDetails",
    components: {
        EqCell,
    },
    props: {
    },
    data() {
        return {
        };
    },
}
</script>
<style scoped>
.app>>>.van-cell__value {
    text-align: left;
}

.app {
    border: 1px solid #E7E5E7;
    border-radius: 10px;
    margin: 15px;
}

.app>>>.van-cell::after {
    border-bottom: 0px;
}
</style>